import gsap from 'gsap'
import { q1O } from '../util/nE'

class ProjectContentItem {
  constructor (el) {
    this.el = el
    this.line = this.el.querySelector('.line')
    this.inners = this.el.querySelectorAll('.js-a')
  }

  init () {
    this.buildTimelineIn()
  }

  buildTimelineIn () {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: this.el,
      },
      defaults: {
        ease: (t) => {
          return q1O(t)
        },
        duration: 1,
      },
    })

    tl.set(this.el, { autoAlpha: 1 })

    if (this.line) {
      tl.fromTo(this.line, {
        scaleX: 0,
      }, {
        scaleX: 1,
      }, 0)
    }

    tl.from(this.inners, {
      yPercent: 50,
      autoAlpha: 0,
      stagger: 0.03,
    }, 0)
  }

  destroy () {
  }
}

export default ProjectContentItem



//////////////////
// WEBPACK FOOTER
// ./scripts/components/ProjectContentItem.js
// module id = 61
// module chunks = 0